import {Types}         from "@Common/types";
import {buildUrlQuery} from "@Common/utils/build-url-query";
import {arrMapToO}     from "@Common/utils/objects";
import {waitTimeout}   from "@Common/utils/wait-timeout";

export const MailingApis = ({fetcher}) => ({

    getMailingLists: async ({entityId = undefined} = {}) => {
        const mls = await fetcher.getJson(`/next-api/mailing/get_mailing_lists/` + (entityId ? buildUrlQuery({entityId}) : ""));
        if (!mls){
            return mls;
        }
        return mls.map((ml) => ({
            count: +ml.purchasedQuantity,
            ...ml,
        }))
    },

    createMailingList: async ({address, zip, count, MFI = "both", listingType = "radius", alternateName}) => {
        return await fetcher.postJson(`/next-api/mailing/create_mailing_list/`, {
            address, zip, count, MFI, listingType,
            alternateName,
        });
    },
    updateMailingList: async ({id, address, name, zip, count, MFI = "both", listingType = "radius", entityId = undefined}) =>
        fetcher.postJson(`/next-api/mailing/update_mailing_list/`, {
            id,
            name,
            address, zip, count, MFI, listingType,
            entityId,
        })
    ,
    getCass: async (mailingListId, entityId=undefined, {doNotWait=true}={}) => {

        // await waitTimeout(200);
        // return {
        //     "statusCode": "CreateMailingList-GA01",
        //     "message": "Invalid User Access",
        //     "internalMessage": "\"Invalid User Access\""
        // };

        return await fetcher.postJson(`/next-api/mailing/get_cass/`, {
            id: ""+mailingListId,
            "forceCass":"0",
            "doNotWait": doNotWait ? "1" : "0",
            entityId,
        });
        // Request: {"id":"123","forceCass":"1", "doNotWait": "1"}
        // Response: {"status": "inProgress", "goodCount": 12, "badCount": 10, "unCassedCount": 10}
        // {
        //   "statusCode": "JAM_DOES_NOT_SAVE_SECRETS",
        //   "message": "Invalid User Access",
        //   "internalMessage": "\"Invalid User Access\""
        // }
    },

    getCassByItemId: async ({itemId, forceCass=false, doNotWait=false}={}) => {

        return await fetcher.postJson(`/next-api/mailing/get_cass_by_item_id/`, {
            itemId: +itemId,
            ...forceCass && {
                forceCass,
            },
            ...doNotWait && {
                doNotWait,
            },
        });

        // {
        //   "cassStatus": [
        //     {
        //       "status": "complete",
        //       "goodCount": 21,
        //       "badCount": 1,
        //       "idList": 8963698
        //     },
        //     {
        //       "status": "complete",
        //       "goodCount": 21,
        //       "badCount": 1,
        //       "idList": 8963697
        //     }
        //   ],
        //   "result": "success"
        // }

        // {
        //   "result": "failure",
        //   "target": "getCassByItemId",
        //   "errors": [
        //     {
        //       "idList": 8963698,
        //       "msg": "There are addresses in the selected list that have not been Cass certified."
        //     }
        //   ]
        // }
    },



    deleteMailingList: async ({id, entityId = undefined}) =>
        fetcher.postJson(`/next-api/mailing/delete_mailing_list/`, {
            id: ""+id,
            entityId,
        })
    ,

    searchRadius: async (search) => {
        const result = await fetcher.postJson(`/next-api/mailing/search_radius/`, {search});

        if (typeof result === "string") {
            throw {type: "notFound"};
        }
        const value1 = Object["values"](result)[0] as any;
        if (value1?.errors) {
            if(value1?.alternateStreets) {
                throw {type: "alternateStreets", alternateStreets: value1.alternateStreets};
            } else {
                throw {type: "notFound"};
            }
        }
        return result;
    },
    searchRadiusStreetAddresses: async ({searchForm, streetAddresses}) => (
        fetcher.postJson(`/next-api/mailing/get_radius_addresses/`, {
            ...searchForm,
            streetAddresses,
        })
    ),
    getDoNotMailStreets: async ({entityId, streetAddresses}) => (
        fetcher.postJson(`/next-api/mailing/do_not_mail/get_do_not_mail_streets/`, {
            entityId,
            streetAddresses,
        })
    ),

    createRadiusMailingList: async ({searchForm, searchResult, info, entityId = undefined}) => {

        const req = {
            listingType: "radius",
            apm: false,
            ...searchForm,

            ...searchResult,
            ...info,
            listName: info.listName ?? searchForm.address,
            entityId,
        };
        return await fetcher.postJson(`/next-api/mailing/create_mailing_list/`, req);
    },

    uploadFile: async ({file, itemId}) => {
        return await fetcher.postMultipart("/next-api/mailing/uploadFile/", {request: file, idItem: itemId ?? ""});
    },
    requestAssistance: async ({fileName, itemId}) => {
        return await fetcher.postJson("/next-api/mailing/request_assistance/", {fileName, itemId});

        //    {"result":"success","message":"Your address list been sent to a technician who will process it manually and upload it to your account. You should get a response in 1-2 business days."}
    },
    createUploadMailingList: async ({data, countryCode, info, entityId = undefined}) => {

        return await fetcher.postJson(`/next-api/mailing/create_mailing_list/`, {
            data,
            "listingType":"upload",
            ...info,
            countryCode,
            entityId,
        });

        //    {  "result": "success",  "idList": 7151019}
    },
    getMailingListDetails: async (mailingListId) => {

        return await fetcher.getJson(`/next-api/mailing/get_mailing_list_details/${mailingListId}`);

        //    {  "addresses":[{"idPrimary":1598610020,"idList":7102907,"name":"test "}]}
    },
    updateMailingAddress: async (edited, entityId) => {
        const result = await fetcher.postJson("/next-api/mailing/update_mailing_list_address/", {
            ...edited,
            idList: "" + edited.idList,
            addressId: edited.idPrimary,
            zipcode: edited.zip,
            name: edited.name ?? "",
            entityId,
        });
        if (result?.result === "failure") {
            throw result.errors?.msg ?? "Unknown error";
        }
        return result;
        // Update address in the list :
        // URL :mailing/update_mailing_list_address/
        // Request :
        // const request = {
        //     "addressId": "1629460875",
        //     "idList": "7249954",
        //     "name": "DAN MCKENZIE",
        //     "name2": "THE MCKENZIE LAW FIRM, LLC",
        //     "address": "123 FOREST PARK BLVD",
        //     "address2": "",
        //     "city": "FORTWORTH",
        //     "state": "TX",
        //     "zipcode": "76110"
        // }
        // Response :
        // {  "result": "success",  "addressId": 1629460875,  "message": "Address successfully updated."}
    },

    addMailingAddress: async (address, entityId, idList) => {

        const result = await fetcher.postJson("/next-api/mailing/add_mailing_list_address/", {
            ...address,
            idList: "" + idList,
            zipcode: address.zip,
            name: address.name ?? "",
            name2: address.name2 ?? "",
            address2: address.address2 ?? "",
            entityId,
        });
        if (result?.result === "failure") {
            throw result.errors?.msg ?? "Unknown error";
        }
        return result;

        // URL : mailing/add_mailing_list_address/
        // Request :
        // {"idList":"7249954","name":"DAN MCKENZIE 234723","name2":"THE MCKENZIE LAW FIRM, LLC","address":"123 FOREST PARK BLVD","address2":"","city":"FORT WORTH","state":"TX","zipcode":"76110"}
        // Response :
        // {  "result": "success",  "addressId": 1629460875,  "message": "Address successfully created."}
        // return {  "result": "success",  "addressId": Date.now(),  "message": "Address successfully created."};
    },
    deleteMailingAddress: async (address) => {
        return await fetcher.getJson(`/next-api/mailing/delete_mailing_list_address/${address.idPrimary}`)
        // return await fetcher.postJson("/next-api/mailing/delete_mailing_list/", {
        //     addressId: address.idPrimary,
        //     idList: address.idList,
        // })
        // Delete an address from the list :
        // URL : mailing/delete_mailing_list_address/1629460875
        // Response :{  "result": "success",  "message": "Address deleted successfully."}
    },
    downloadMailingList: async (address) => {
        return await fetcher.getJson(`/next-api/mailing/download_mailing_list/${address.id}`, undefined, false);
    },



    searchStreet: async (form, entityId) => {
        return await fetcher.postJson("/next-api/mailing/search_street/", {streets:[form], entityId});
    },
    createStreetList: async ({streets, info, entityId = undefined}) => {
        return await fetcher.postJson("/next-api/mailing/create_mailing_list/", {
            ...info,
            listName: info.listName || streets[0].street.address,
            "listingType": "street",
            entityId,
            addresses: arrMapToO(
                streets,
                (r) => ({
                    ...r.street,
                    addresses: r.addresses,
                }),
                (r) => (
                    r.street.address + r.street.zip_code
                ),
            ),
        });
    },

    updateAlternateName: async ({idList, alternateName}) => {
        return await fetcher.postJson("/next-api/mailing/update_alternate_name/", {idList, alternateName});
    },

    updateListName: async ({idList, name}:Types.Apis.Payloads.Mailing.UpdateListName.Request): Promise<void> => (
        fetcher.postJson("/next-api/mailing/updateListName", {idList, name})
    ),

    demographics: {
        getTargets: async ({entityId = undefined}) => {
            return await fetcher.getJson("/next-api/mailing/getTargets/" + (entityId ? buildUrlQuery({entityId}) : ""));
        },
        getCustomizedInputsConfig: async (idSearch) => {
            return await fetcher.getJson(`/next-api/mailing/getCustomizedInputs/${idSearch}`);
        },
        search: async ({idSearch, selectedTargets, searchType, geography}) => {
            return await fetcher.postJson(`/next-api/mailing/demographicResults/`, {
                idSearch,
                selectedTargets,
                searchType,
                geography,
            });
        },

        createMailingList: async ({idSearch, finalize, inputsCustomization, narrowing, entityId = undefined}) => {

            return await fetcher.postJson("/next-api/mailing/create_mailing_list/", {
                "listingType": "demographicList",

                idSearch,
                "selectedTargets": inputsCustomization,

                // "mailOption": "all/limit",
                "mailOption": narrowing.mailOptions.mailOption,


                // "alternativeName": "test",

                // "mailCount": "105",
                "mailCount": narrowing.mailOptions.mailCount ?? narrowing.searchResult.total,
                "useType": narrowing.mailOptions.useType,

                // "useType": "single",

                // "listName": "Tony DeAnna - 2020-03-04",
                // "name2Override": "or_occupant",
                ...finalize,

                "query": narrowing.searchResult.query,
                entityId,
            });
        },
    },

    eddm: {
        searchEddmList: async ({search, isMapBased = false}) => {
            // console.log("search", search);
            const result = await fetcher.postJson("/next-api/mailing/search_eddm_list/", search);
            if (result.errors) {
                throw result.errors.msg ?? "Unknown server error";
            }
            if (!result.eddmRoutes?.length) {
                throw `Cannot find any ${isMapBased ? 'neighborhood' : 'EDDM'} routes`;
            }
            // return result["EDDM Response"];
            return {
                allRoutes: result.eddmRoutes,
                searchRequestServerKey: result.eddmRequest,
                warningMsg: result?.warningMsg,
            };
        },
        createEddmList: async ({listName, routes, searchRequestServerKey, entityId = undefined}) => {

            return await fetcher.postJson("/next-api/mailing/create_mailing_list/", {
                "listingType":"eddmList",
                listName,
                eddmRoutes: routes,
                eddmRequest: searchRequestServerKey,
                entityId,
            });
        },
        getCarrierRouteDemographics: async ({carrierRoutes, demographicKeys}) => {

            return await fetcher.postJson("/next-api/mailing/get_carrier_route_demographics/", {
                carrierRoutes,
                demographicKeys,
            });
        },
    },

    homeowners: {
        searchHomeowners: async (request) => {
            return await fetcher.postJson("/next-api/mailing/search_homeowners/", request);
        },
        createHomeownerList: async ({searchRequest, info, entityId = undefined}) => {

            const req = {
                listingType: "homeowners",
                ...searchRequest,
                ...info,
                entityId,
                listName: info.listName ?? "New Homeowners",
            };
            return await fetcher.postJson(`/next-api/mailing/create_mailing_list/`, req);
        },
    },

    crm: {
        getCrmList: async ({entityId = undefined}) => {
            return await fetcher.postJson("/next-api/mailing/get_crm_list", {
                entityId,
            });
        },
        getCrmListAddress: async ({crmList, entityId = undefined, defaultName = undefined, defaultName2 = undefined}) => {
            return await fetcher.postJson("/next-api/mailing/get_crm_list_address/", {
                entityId,
                crmList,
                defaultName,
                defaultName2
            });
        },
    },

    decondo: {

        // /next-api/mailing/get_street_names/
        // {
        //   "E|100th Street": "E 100th Street",
        //   "W|100th Street": "W 100th Street",
        // }
        getStreetNames: async () => await fetcher.getJson("/next-api/mailing/get_street_names/"),

        // POST /next-api/mailing/get_buildings/
        // {"street":"W|102nd Street"}
        // {
        //   "10|W|102nd Street|10025": "10 W 102nd Street, 10025",
        //   "102|W|102nd Street|10025": "102 W 102nd Street, 10025",
        //   "11|W|102nd Street|10025": "11 W 102nd Street, 10025",
        // }

        // Or
        // {"result":"failure","errors":{"target":"get_buildings_on_street","msg":"No file extension present"}}
        getBuildings: async (streetKey) => await fetcher.postJson("/next-api/mailing/get_buildings/", {"street":streetKey}),


        // /next-api/mailing/retrieve_addresses/
        // Request : {"building":"200|W|102nd Street|10025"}
        //{
        //   "street": {
        //     "name": "W 102nd Street",
        //     "key": "W|102nd Street",
        //     "begin": "200",
        //     "end": "200"
        //   },
        //   "addressList": [
        //     {
        //       "name": " Current Resident",
        //       "name2": "",
        //       "address": "200 W 102nd Street",
        //       "address2": "",
        //       "city": "New York",
        //       "state": "NY",
        //       "zip": "10025",
        //       "street": "102nd Street"
        //     },
        //     {
        //       "name": " Current Resident",
        //       "name2": "",
        //       "address": "200 W 102nd Street",
        //       "address2": "APT 4W",
        //       "city": "New York",
        //       "state": "NY",
        //       "zip": "10025",
        //       "street": "102nd Street"
        //     }
        //   ]
        // }
        retrieveAddresses: async (buildingKey) => await fetcher.postJson("/next-api/mailing/retrieve_addresses/", {"building":buildingKey}),



        //
        // Url: /next-api/mailing/create_mailing_list/
        // Request :
        // {
        // 	"buildings": ["200|W|102nd Street|10025",
        // 		"10|W|102nd Street|10025"
        // 	],
        // 	"addressList": [{
        // 			"name": " Current Resident",
        // 			"name2": "",
        // 			"address": "200 W 102nd Street",
        // 			"address2": "",
        // 			"city": "New York",
        // 			"state": "NY",
        // 			"zip": "10025",
        // 			"street": "102nd Street"
        // 		},
        // 		{
        // 			"name": " Current Resident",
        // 			"name2": "",
        // 			"address": "200 W 102nd Street",
        // 			"address2": "APT 4W",
        // 			"city": "New York",
        // 			"state": "NY",
        // 			"zip": "10025",
        // 			"street": "102nd Street"
        // 		},
        // 		{
        // 			"name": " Current Resident",
        // 			"name2": "",
        // 			"address": "10 W 102nd Street",
        // 			"address2": "",
        // 			"city": "New York",
        // 			"state": "NY",
        // 			"zip": "10025",
        // 			"street": "102nd Street"
        // 		}
        // 	],
        // 	"listingType": "co-op/condo building",
        // 	"listName": "Testing"
        // }

        // @ts-ignore
        createDecondoML: async ({listName, buildings, entityId = undefined}) => {
            return await fetcher.postJson("/next-api/mailing/create_mailing_list/", {
                listName,
                listingType: "decondo",
                buildings: buildings.map((b) => b.building.key),
                addressList: buildings.map((b) => b.addressList).flat(),
                entityId,
            })
        },
    },

    dnm: {
        getDoNotMailList: async (officeId) => await fetcher.getJson(`/next-api/mailing/doNotMail/list` + (officeId ? buildUrlQuery({officeId}) : "")),
        addDoNotMailAddress: async (address, officeId, {skipValidation=false}={}) => await fetcher.postJson("/next-api/mailing/doNotMail/address", {
            ...address,
            officeId,
            skipValidation,
        }),
        addBulkDoNotMailAddress: async (addresses, idEntity) => await fetcher.postJson("/next-api/mailing/doNotMail/addBulkAddressList", {
            addresses,
            idEntity,
        }),
        deleteDoNotMailAddress: async (idPrimary, idEntity) => await fetcher.deleteJson("/next-api/mailing/doNotMail/address", {idPrimary, idEntity}),
    },


    dedupe: {
        getDuplicates: async (mlIds) =>
            (await fetcher.postJson("/next-api/mailing/dedupe_mailing_list/", mlIds.map((id) => ({id}))))
            .dedupeAddresses
        ,
    },
});
